import { render } from "./InstantMeetingButton.vue?vue&type=template&id=4f80d806&scoped=true"
import script from "./InstantMeetingButton.vue?vue&type=script&lang=js"
export * from "./InstantMeetingButton.vue?vue&type=script&lang=js"

import "./InstantMeetingButton.vue?vue&type=style&index=0&id=4f80d806&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f80d806"]])

export default __exports__